// @noflow
import { copyDayEvents, selectDay } from '~/core/state/ui/schedule/actions';
import {
    getCopyDay,
    getCurrentScheduleEvent,
    getDataId,
    getDayScheduleEvents,
    getScheduleMode,
    getSelectedDay,
    getSelectedEvent
} from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import Day from './component';
import { fromJS } from 'immutable';
import { getPropsForProduct } from '~/core/state/products/selectors';
import { scheduleModesEnum } from '~/core/constants/schedule';

const mapStateToProps = (state, ownProps) => {
    const { isDayDragging, temporaryStartTime } = ownProps;
    const selectedDay = getSelectedDay(state, ownProps);
    const selectedEvent = getSelectedEvent(state, ownProps);
    let events = getDayScheduleEvents(state, ownProps);
    const scheduleMode = getScheduleMode(state, ownProps);
    const copyDay = getCopyDay(state, ownProps);
    const currentEvent = getCurrentScheduleEvent(state, ownProps);
    const productId = getDataId(state, ownProps);
    const maxEvents = (getPropsForProduct(state, { id: productId }) || fromJS({})).get('maxEvents', 6);

    if (isDayDragging) {
        const updatingEventIndex = selectedEvent.get('eventIndex') + 1;
        events = events.map((event, i) => {
            if (i === 0) {
                return event;
            }
            const timeStart = {
                [i === updatingEventIndex]: temporaryStartTime,
                [i < updatingEventIndex]: Math.min(
                    event.get('start'),
                    temporaryStartTime - (updatingEventIndex - i) * 15
                ),
                [i > updatingEventIndex]: Math.max(
                    event.get('start'),
                    temporaryStartTime + (i - updatingEventIndex) * 15
                )
            }[true];
            return event.set('start', timeStart);
        });
    }

    return {
        ...ownProps,
        copyDay,
        currentEvent,
        events,
        maxEvents,
        scheduleMode,
        selectedDay
    };
};

const mapDispatchToProps = {
    copyDayEvents,
    selectDay
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { componentId, dayIndex } = ownProps;
    const { copyDayEvents, selectDay } = dispatchProps;
    const { scheduleMode } = stateProps;
    return {
        ...stateProps,
        ...ownProps,
        selectDay: () => {
            if (scheduleMode === scheduleModesEnum.COPY_DAY) {
                copyDayEvents({ componentId, dayIndex });
            } else {
                selectDay({ componentId, dayIndex });
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Day);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/day/index.js